import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getPracticeTestsAsync } from "./practice.async";

const initialState = {
  practiceLoader: false,
  practiceData: [],
};

export const practiceSlice = createSlice({
  name: "study",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(getPracticeTestsAsync.pending),
      (state, action) => {
        state.practiceLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getPracticeTestsAsync.fulfilled),
      (state, action) => {
        state.practiceLoader = false;
        state.practiceData = action.payload.data;
      }
    );

    builder.addMatcher(
      isAnyOf(getPracticeTestsAsync.rejected),
      (state, action) => {
        state.practiceLoader = false;
      }
    );
  },
  reducers: {
    emptyPractice: () => initialState,
    resetPracticeLoader: (state) => {
      state.practiceLoader = false;
    },
  },
});

export const { emptyPractice, resetPracticeLoader } = practiceSlice.actions;

export default practiceSlice.reducer;
